import { evalScript, updateThemeWithAppSkinInfo } from "../js/main";
import { LocalStorageKeys } from "./constant";
import { saveOnStorage } from "./helpers";
const csInterface = new window.CSInterface();
export const getFileDataAsJSON = async (filePath: string) => {
  const extendScript = `
            function readJSONFile(filePath) {
                var file = new File(filePath);
                
                if (!file.exists) {
                    throw new Error("File not found: " + filePath);
                }

                file.open('r');
                var fileContent = file.read();
                file.close();
                return fileContent;
            }

            try {
                var result = readJSONFile("${filePath}");
                result;  // Return the result back to JavaScript
            } catch (e) {
                "Error: " + e.message;  // Return error message if an exception occurs
            }
        `;

  let result = await evalScript(csInterface, extendScript);
  //   // console.log("result", result);
  if ((result as string).includes("File not found"))
    return { data: null, error: "File Not Found" };
  try {
    return { data: JSON.parse(result as string) };
  } catch {
    return { data: result };
  }
};

// Write binary data to file using `cep.fs`
export const saveBase64AsFileWithCEP = async (filePath, base64Data) => {
  // Write the binary string to the file using `cep.fs.writeFile`
  const result = window.cep.fs.writeFile(
    filePath,
    base64Data,
    window.cep.encoding.Base64
  );

  if (result.err === window.cep.fs.NO_ERROR) {
    console.log("File saved successfully at:", filePath);
    // await showAlertInInDesign("file saved at: " + filePath, "Success");
    return "File saved successfully at:" + filePath;
  } else {
    console.error("Error saving file, error code:", result.err);
    // await showAlertInInDesign("file saving error: " + result.err, "Error");
    return "Error saving file, error code:" + result.err;
  }
};

export const saveJSONdataAsFile = async (filePath: string, data: any) => {
  console.log("filePath", filePath);

  // Convert the data object to a JSON string
  const jsonData = JSON.stringify(data, null, 2);

  const extendScript = `
            function writeJSONToFile(filePath, jsonData) {
                var file = new File(filePath);
                
                try {
                    // Check if the directory exists
                    var folder = file.parent;
                    if (!folder.exists) {
                        return "Error: Directory does not exist - " + folder.fsName;
                    }
                    
                    file.encoding = "UTF-8";
                    
                    if (!file.open("w")) {  // Attempt to open the file for writing
                        return "Error: Unable to open file - " + file.fsName;
                    }
                    
                    file.write(jsonData);  // Write the JSON data
                    file.close();  // Close the file after writing
                    
                    return "Success: File written to - " + file.fsName;
                } catch (e) {
                    return "Error: " + e.message;
                }
            }

            writeJSONToFile("${filePath}", ${JSON.stringify(jsonData)});
        `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

export const getDocumentPaths = async () => {
  const extendScript = `
      function getPaths() {
          if (app.documents.length > 0) {
              var activeDoc = app.activeDocument;

              // Check if the document is saved
              if (activeDoc.saved) {
                  var templatePath = activeDoc.fullName.fsName;
                  var outputPath = activeDoc.fullName.path + "/merged_" + activeDoc.name;
                  return templatePath + "|" + outputPath;
              } else {
                  return "Error: The document is not saved. Please save the document first.";
              }
          } else {
              return "Error: No active document";
          }
      }

      getPaths();
  `;

  let result = await evalScript(csInterface, extendScript);

  if ((result as string).startsWith("Error:")) {
    console.error(result);
    return { error: result };
  }

  const [templateFilePath, outputFilePath] = (result as string)
    .replace(/\\/g, "/")
    .split("|");
  return { templateFilePath, outputFilePath };
};

export const getPlatform = async (): Promise<string> => {
  const extendScript = `
        function getPlatform() {
          try {
              // Determine the home directory based on the OS
              if ($.os.indexOf("Windows") !== -1) {
                  return "WINDOWS"
              } else {
                  homeDir = Folder.userData.parent.fsName; // /Users/Username or /home/username
                  configDir = new Folder(homeDir + "/ERPConnector_MDS_Adobe");
                  return "MAC"
              }
          } catch (e) {
              // Provide a fallback path (e.g., the home directory) or handle the error appropriately
              return "Error: Cannot detect platform";
          }
      }
      getPlatform()
    `;
  let result = await evalScript(csInterface, extendScript);
  return result as string;
};

export const getAssetFolder = async () => {
  const extendScript = `
        function getAssetFolder() {
          var homeDir;
          var configDir
          try {
              // Determine the home directory based on the OS
              if ($.os.indexOf("Windows") !== -1) {
                  homeDir = Folder.userData.parent.parent.fsName; // C:\Users\Username
                  configDir = new Folder(homeDir + "\\\\ERPConnector_MDS_Adobe\\\\assets");
              } else {
                  homeDir = Folder.userData.parent.fsName; // /Users/Username or /home/username
                  configDir = new Folder(homeDir + "/ERPConnector_MDS_Adobe/assets");
              }
            
              // Check if the directory exists, and if not, create it
              if (!configDir.exists) {
                  if (!configDir.create()) {
                    return "Error: Folder is missing";
                  }
              }
              // Return the full path to the configuration file
              return configDir.fsName;
          } catch (e) {
              // Provide a fallback path (e.g., the home directory) or handle the error appropriately
              return "Error: Folder is missing";
          }
      }
      getAssetFolder()
    `;
  let result = await evalScript(csInterface, extendScript);
  return (result as string).replace(/\\/g, "\\\\");
};
export const getUsableFolder = async () => {
  const extendScript = `
        function getUsableFolder() {
          var homeDir;
          var configDir
          try {
              // Determine the home directory based on the OS
              if ($.os.indexOf("Windows") !== -1) {
                  homeDir = Folder.userData.parent.parent.fsName; // C:\Users\Username
                  configDir = new Folder(homeDir + "\\\\ERPConnector_MDS_Adobe");
              } else {
                  homeDir = Folder.userData.parent.fsName; // /Users/Username or /home/username
                  configDir = new Folder(homeDir + "/ERPConnector_MDS_Adobe");
              }
            
              // Check if the directory exists, and if not, create it
              if (!configDir.exists) {
                  if (!configDir.create()) {
                    return "Error: Folder is missing";
                  }
              }
              // Return the full path to the configuration file
              return configDir.fsName;
          } catch (e) {
              // Provide a fallback path (e.g., the home directory) or handle the error appropriately
              return "Error: Folder is missing";
          }
      }
      getUsableFolder()
    `;
  let result = await evalScript(csInterface, extendScript);
  return (result as string).replace(/\\/g, "\\\\");
};
export const getConfigFilePath = async () => {
  let usableFolder = await getUsableFolder();
  let platform = (await getPlatform()) as string;
  if (usableFolder.includes("Error")) {
    return usableFolder;
  }
  return (
    usableFolder + (platform === "WINDOWS" ? "\\\\config.json" : "/config.json")
  );
};

export const saveXMLToFile = async (filePath, xmlData) => {
  const extendScript = `
    function writeXMLToFile(filePath, xmlData) {
      try {
        var file = new File(filePath);
        file.encoding = "UTF-8";
        file.open("w"); // Write mode
        file.write(xmlData);
        file.close();
        return "Success";
      } catch (e) {
        return "Error: " + e.message;
      }
    }

    writeXMLToFile("${filePath}", ${JSON.stringify(xmlData)});
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

export const saveCSVToFile = async (filePath: string, data: string) => {
  const extendScript = `
      function writeCSVToFile(filePath, csvData) {
          try {
              var file = new File(filePath);
              file.encoding = "UTF-8";
              file.open("w");  // Write mode
              if (file.exists && !file.open("w")) { 
                  // If the file exists but cannot be opened in "write" mode
                  return "Error: The file "+filePath+" is open in another application and cannot be overwritten.";
              }
              file.write(csvData);
              file.close();
              return "Success";
          } catch (e) {
              return "Error: " + e.message;
          }
      }

      writeCSVToFile("${filePath}", ${JSON.stringify(data)});
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

// export const openXMLMergePanelAndSelectXML = async (xmlFilePath) => {
//   const extendScript = `
//     function openXMLMergePanelAndSelectXML(dataSourcePath) {
//       try {
//         docref = app.documents.add();

//         var xmlFileRef = new File(path);
//         if (xmlFileRef.exists)
//         {
//             docref.importXML(xmlFileRef);
//             //docref.insertLabel("XMLMereged", "Yes");
//         }

//         app.menuActions.itemByName('Show Structure').invoke();
//       } catch (e) {
//         return "Error: " + e.message;
//       }
//     }

//     openXMLMergePanelAndSelectXML("${xmlFilePath}");
//   `;

//   let result = await evalScript(csInterface, extendScript);
//   return result;
// };

export const toogleStructurePane = async () => {
  const extendScript = `
    function toogleStructurePane() {
      try {
          var viewMenu = app.menus.item("$ID/Main").submenus.item("$ID/View");
          var structureSubMenu = viewMenu.submenus.item("Structure");
      
          // Check if "Show Structure" or "Hide Structure" is available
          var showStructureItem = structureSubMenu.menuItems.itemByName("Show Structure");
          var hideStructureItem = structureSubMenu.menuItems.itemByName("Hide Structure");
      
          // If the structure is visible (i.e., "Hide Structure" exists), hide it first
          if (hideStructureItem.isValid) {
              hideStructureItem.associatedMenuAction.invoke();
             
          }
          else if (showStructureItem.isValid) {
            showStructureItem.associatedMenuAction.invoke();
            toogleStructurePane()
          } else {
              alert("Show Structure option not available.");
          }
      } catch (e) {
        return "Error: " + e.message;
      }
    }

    toogleStructurePane();
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};
// export const openXMLMergePanelAndSelectXML = async (xmlFilePath) => {
//   const extendScript = `
//     function openXMLMergePanelAndSelectXML(dataSourcePath) {
//       try {
//         if (app.documents.length > 0) {
//           var myDocument = app.activeDocument;

//           // Import the XML file
//           var xmlFile = new File(dataSourcePath);
//           myDocument.importXML(xmlFile);
//           return "XML data merged successfully with new pages for each record.";
//         } else {
//           return "Error: No active document";
//         }
//       } catch (e) {
//         return "Error: " + e.message;
//       }
//     }

//     openXMLMergePanelAndSelectXML("${xmlFilePath}");
//   `;

//   let result = await evalScript(csInterface, extendScript);
//   return result;
// };

export const openXMLMergePanelAndSelectXML = async (xmlFilePath) => {
  const extendScript = `
    function openXMLMergePanelAndSelectXML(dataSourcePath) {
      try {
        if (app.documents.length > 0) {
          var myDocument = app.activeDocument;

          // Function to recursively untag and remove all XML elements safely
          function safeUntagAllElements(element) {
            for (var i = element.xmlElements.length - 1; i >= 0; i--) {
              safeUntagAllElements(element.xmlElements.item(i)); // Recursively untag child elements
            }
            try {
              // Safely untag the element
              element.untag();
            } catch (e) {
              // If untagging fails, log the error and continue
              // $.writeln("Failed to untag element: " + e.message);
            }
          }

          // Start by untagging the root XML element
          if (myDocument.xmlElements.length > 0) {
            var rootElement = myDocument.xmlElements.item(0);
            safeUntagAllElements(rootElement); // Recursively untag all elements
          }

          // Import the new XML file
          var xmlFile = new File(dataSourcePath);
          myDocument.importXML(xmlFile);

          return "XML data merged successfully with new pages for each record.";
        } else {
          return "Error: No active document";
        }
      } catch (e) {
        return "Error: " + e.message;
      }
    }

    openXMLMergePanelAndSelectXML("${xmlFilePath}");
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

export const openDataMergePanelAndSelectCSV = async (csvFilePath: string) => {
  const extendScript = `
      function openDataMergePanelAndSelectCSV(dataSourcePath) {
          try {
              if (app.documents.length > 0) {
                  var myDocument = app.activeDocument;

                  var ma = app.menuActions.itemByID ( 108035 );
                  if(ma.properties.checked){
                      ma.invoke();
                  }

                  // Open the Data Merge panel
                  // app.menuActions.itemByName("Utilities/Data Merge").invoke();
                  if (app.panels.item("Data Merge").isValid){
                    app.panels.item("Data Merge").visible = true;
                  }

                  // Select the CSV file as the data source
                  myDocument.dataMergeProperties.selectDataSource(File(dataSourcePath));
                  
                  // ma.invoke();
                  
                  
                  return "Data source selected successfully";
              } else {
                  return "Error: No active document";
              }
          } catch (e) {
              return "Error: " + e.message;
          }
      }

      openDataMergePanelAndSelectCSV("${csvFilePath}");
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

export const showAlertInInDesign = async (
  message: string,
  title: string = "Alert"
) => {
  const extendScript = `
      function showAlert(message, title) {
        try {
            alert(message, title);
            return "Alert displayed successfully";
        } catch (e) {
            return "Error: " + e.message;
        }
       
    }
    showAlert("${message}", "${title}");
  `;

  let result = await evalScript(csInterface, extendScript);
  return result;
};

export const initialseIndesignService = async () => {
  if (csInterface?.hostEnvironment)
    updateThemeWithAppSkinInfo(csInterface.hostEnvironment.appSkinInfo);
  let configFilePath = await getConfigFilePath();
  console.log("initialising....");
  if (configFilePath.includes("Error")) {
    return;
  }
  let { data } = await getFileDataAsJSON(configFilePath);
  console.log("initialising....", configFilePath);
  if (data) {
    console.log("saving on file....", data);
    saveOnStorage(LocalStorageKeys.CONFIG, data);
  }
};

/**
 * Normalizes file path separators based on the host OS platform (MAC or WINDOWS).
 */
export const normalizePath = (filePath: string, platform: string): string => {
  if (!filePath) return "";
  const step1 = filePath.replace(/\\+/g, "/");
  if (platform === "MAC") {
    return step1.replace(/\//g, "/");
  }
  return step1.replace(/\//g, "\\");
};

